import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Button from "react-bootstrap/Button";
import Alert from "react-bootstrap/Alert";

function UserInput(props) {
  const [number, setNumber] = useState();
  const [tooHighOrLow, setTooHighOrLow] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [alertUser, setAlertUser] = useState(false);
  const [variant, setVariant] = useState();

  const numberChangeHandler = (number) => {
    const incomingNumber = Number(number.target.value);
    setNumber(incomingNumber);
    if (incomingNumber <= 0) {
      setAlertUser(true);
      setAlertText("Not a number between 1-100. This value is too low.");
      setVariant("info");
      setTooHighOrLow(true);
    }
    if (incomingNumber >= 101) {
      setAlertUser(true);
      setAlertText("Not a number between 1-100. This value is too high.");
      setVariant("info");
      setTooHighOrLow(true);
    }
    if (incomingNumber >= 1 && incomingNumber <= 100) {
      setTooHighOrLow(false);
      setAlertUser(false);
    }
  };

  const submitNumber = (z) => {
    z.preventDefault();
    const incomingNumber = number;
    if (incomingNumber >= 1 && incomingNumber <= 100) {
      props.onNumberSubmission(number);
      props.onSetOldNumbers((prevNumbers) => {
        return [...prevNumbers, number];
      });
      z.target[0].value = "";
      setNumber("");
    } else {
      if (incomingNumber <= 0 || incomingNumber >= 101) {
        setAlertUser(true);
        setAlertText(
          "This number was not submitted. Please select a number between 1-100."
        );
        setVariant("info");
        z.target[0].value = "";
        setNumber("");
      }
      setTooHighOrLow(true);
    }
  };

  useEffect(() => {
    if (props.alertUser === true) {
      setVariant(props.messageBackVariant);
      setAlertText(props.messageBackAlertText);
    }
    if (props.alertUser === false) {
      setVariant("");
      setAlertText("");
    }
  }, [props.messageBackVariant, props.messageBackAlertText, props.alertUser]);

  return (
    <form onSubmit={submitNumber}>
      <InputGroup className="mb-3">
        <InputGroup.Text><h1>Enter a guess:</h1></InputGroup.Text>
        <Form.Control
          placeholder="Enter a number between 1-100"
          onChange={numberChangeHandler}
          disabled={props.endgame}
          style={{
            border: tooHighOrLow ? "5px solid rgb(255 62 80 / 79%)" : "",
            borderRadius: tooHighOrLow ? "5px" : "",
            fontSize: "1.5rem",
            fontWeight: "bold",
          }}
        />
        <Button variant="primary" disabled={props.endgame} type="submit" style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
          Submit Your Guess
        </Button>
      </InputGroup>
      {alertUser ? (
        <Alert key={variant} variant={variant}>
          {alertText}
        </Alert>
      ) : null}
    </form>
  );
}

export default UserInput;
